<template>
  <router-link class="value-project-name" :to="routeParams" :data-action="model + '.show'" :data-action-id="item.id">
    <div class="value-project-name--name">{{item.name}}</div>
    <div class="value-project-name--lead-mask" v-if="item.lead_mask_name">{{$t('models.project.lead_mask')}}: {{item.lead_mask_name}}</div>
  </router-link>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    routeParams(){
      return { name: this.model + '_show' , params: { id: this.item.id } }
    }
  }
}
</script>
<style lang="scss" scoped>
.value-project-name{
  display: block;
}
.value-project-name--name{
  font-weight: $font-medium;
  color: $ink;
  font-size: 16px;
}
.value-project-name--lead-mask{
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// CollectionValueProjectName.vue?1ff125d3